import * as types from './mutation-types';
import growplantaskService from '../../services/growplantask'
import { createServiceCall } from '../actionsUtil'

export const getGrowplanInitial = createServiceCall({
  mainAction: types.GET_GROWPLANS_INITIAL_REQUEST,
  serviceFunction: growplantaskService.getGrowplanInitial,
  successAction: types.GET_GROWPLANS_INITIAL_SUCCESS,
  successDataProperty: "getLifecycleStartInfo",
  failureAction: types.GET_GROWPLANS_INITIAL_FAILURE
});

export const getPlatformGroups = createServiceCall({
  mainAction: types.GET_PLATFORM_GROUPS_REQUEST,
  serviceFunction: growplantaskService.getPlatformGroups,
  successAction: types.GET_PLATFORM_GROUPS_SUCCESS,
  successDataProperty: "getPlatformGroups",
  failureAction: types.GET_PLATFORM_GROUPS_FAILURE
});

export const getLifeyclesByStrain = createServiceCall({
  mainAction: types.GET_LIFECYCLE_STRAIN_REQUEST,
  serviceFunction: growplantaskService.getLifeyclesByStrain,
  successAction: types.GET_LIFECYCLE_STRAIN_SUCCESS,
  successDataProperty: "getLifeyclesByStrain",
  failureAction: types.GET_LIFECYCLE_STRAIN_FAILURE
});

export const setPlatformsGroups = ({commit}) => {
  commit(types.SET_PLATFORMS)
}
